export default "__VITE_ASSET__q4pw_HV3__"